'use client';

import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import OrdermageLogoSVG from '@/assets/images/ordermage-logo.svg';
import { Layout } from '@/shared/ui/layout';

const href = 'https://ordermage.com';

type Props = ComponentProps<typeof Layout>;

export const Copyright = (props: Props) => {
    const t = useTranslations();
    return (
        <Layout
            {...props}
            media={{
                ...props.media,
                initial: {
                    display: 'flex',
                    fontSize: '.875rem',
                    gap: '0.75rem',
                    flexDirection: 'row',
                    alignItems: 'center',
                    ...props.media?.initial,
                },
            }}
        >
            <p>
                {`${t('FOOTER.BOTTOM.CREATED_WITH')} `}
                <a href={href} target="_blank" rel="noopener noreferrer">
                    {t('FOOTER.BOTTOM.ORDERMAGE')}
                </a>
            </p>
            <Layout
                element="a"
                media={{
                    initial: {
                        display: 'flex',
                        width: 'auto',
                        height: '1rem',
                        color: 'var(--color-gray-200)',
                    },
                }}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
            >
                <OrdermageLogoSVG role="img" aria-label="OrderMage Logo" />
            </Layout>
        </Layout>
    );
};
